import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    info: {
      main: "#6B6B6B",
    },
    primary: {
      main: "#212121",
    },
    secondary: {
      main: "#14008D",
    },
  },
});

export default theme;
